module.exports = __webpack_public_path__ + "img/print.bc842460.svg";